export type TaskHoursLeftKey =
  | 'timeLeftMinutes'
  | 'timeLeftDaysHours'
  | 'timeLeftDays'
  | 'timeLeftHours'

export type TaskHoursLeftTranslator = (
  key: TaskHoursLeftKey,
  values: { count?: number; days?: number; hours?: number }
) => string

/** Localized hours-left label for task cards (tasksPage.activeSection). */
export function formatTaskHoursLeft(
  hours: number,
  t: TaskHoursLeftTranslator
): string {
  if (hours < 1) {
    const count = Math.max(1, Math.round(hours * 60))
    return t('timeLeftMinutes', { count })
  }

  // Round once, then split: rounding the remainder alone printed «15d 24h».
  const totalHours = Math.round(hours)
  const days = Math.floor(totalHours / 24)
  const remainingHours = totalHours % 24
  if (days > 0) {
    // «7d», not «7d 0h»: a zero reads like the letter O.
    return remainingHours === 0
      ? t('timeLeftDays', { days })
      : t('timeLeftDaysHours', { days, hours: remainingHours })
  }

  return t('timeLeftHours', { hours: remainingHours })
}
